import React, { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import type { AssetRef } from '../../types/place';
import VideoPlayer from '../players/VideoPlayer';

interface DeafVideoWidgetProps {
    video: AssetRef | null;
}

const DeafVideoWidget: React.FC<DeafVideoWidgetProps> = ({video}) => {


    if ( !video) {
        return <div>Loading...</div>
    }

    //const video = translations[currentAsset]


    return (
        <div>
            <VideoPlayer video={video.id} />
        </div>
    );
};

export default DeafVideoWidget;
